export { FilesHub, FilesHubCommandBar, Props } from 'owa-group-files-hub';
export { GroupFilesHubSxSLayerView } from './components/GroupFilesHubSxSLayerView';
